import api from './api';
import { uploadImageToCloudinary } from './cloudinaryService';

/** File/Blob görseli varsa doğrudan Cloudinary'ye yükler (Railway'den geçmez). */
/** Sınırsız kullanım için boş string gönderilir (null FormData'da düşer). */
function appendCampaignFormValue(formData, key, value) {
  if (key === 'maxUsageCount' || key === 'minOrderAmount') {
    formData.append(key, value == null || value === '' ? '' : String(value));
    return;
  }
  if (value === null || value === undefined) return;
  if (typeof value === 'boolean') {
    formData.append(key, value.toString());
    return;
  }
  formData.append(key, value);
}

async function maybeCloudinaryCampaignImage(campaignData) {
  const img = campaignData.image;
  if (!img || typeof img.size === 'undefined') {
    return campaignData;
  }
  try {
    const url = await uploadImageToCloudinary(img, 'campaign');
    const next = { ...campaignData };
    delete next.image;
    next.imageUrl = url;
    return next;
  } catch (e) {
    console.warn('Kampanya Cloudinary yüklemesi atlandı, sunucu upload:', e?.message);
    return campaignData;
  }
}

export const campaignService = {
  createCampaign: async (campaignData) => {
    try {
      const prepared = await maybeCloudinaryCampaignImage(campaignData);
      const formData = new FormData();

      Object.keys(prepared).forEach(key => {
        if (key === 'image') {
          if (prepared.image) {
            formData.append('image', prepared.image);
          }
        } else if (key === 'imageUrl') {
          formData.append('imageUrl', prepared.imageUrl);
        } else if (
          key === 'elements' ||
          key === 'backgroundColor' ||
          key === 'recurrence' ||
          key === 'scopeCategoryIds' ||
          key === 'scopeProductIds'
        ) {
          formData.append(key, JSON.stringify(prepared[key]));
        } else {
          appendCampaignFormValue(formData, key, prepared[key]);
        }
      });

      const response = await api.post('/api/business/campaigns', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error('Kampanya oluşturma hatası:', error);
      throw error;
    }
  },

  getCampaigns: async () => {
    try {
      const response = await api.get('/api/business/campaigns');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCampaign: async (id, campaignData) => {
    try {
      const prepared = await maybeCloudinaryCampaignImage(campaignData);
      const formData = new FormData();

      Object.keys(prepared).forEach(key => {
        if (key === 'image') {
          if (prepared[key] instanceof File) {
            formData.append('image', prepared[key]);
          }
        } else if (key === 'imageUrl') {
          formData.append('imageUrl', prepared.imageUrl);
        } else if (key === '_id' || key === '__v' || key === 'createdAt' || key === 'updatedAt') {
          return;
        } else if (
          key === 'recurrence' ||
          key === 'scopeCategoryIds' ||
          key === 'scopeProductIds'
        ) {
          formData.append(key, JSON.stringify(prepared[key]));
        } else {
          appendCampaignFormValue(formData, key, prepared[key]);
        }
      });

      const response = await api.put(`/api/business/campaigns/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error('Kampanya güncelleme hatası:', error);
      throw error;
    }
  },

  deleteCampaign: async (id) => {
    try {
      const response = await api.delete(`/api/business/campaigns/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getCampaignStats: async () => {
    try {
      const response = await api.get('/api/business/campaigns/stats');
      return response.data;
    } catch (error) {
      console.error('Kampanya istatistikleri getirme hatası:', error);
      throw error;
    }
  },

  getCampaignPerformance: async () => {
    try {
      const response = await api.get('/api/business/campaigns/performance');
      return response.data;
    } catch (error) {
      console.error('Kampanya performans analizi getirme hatası:', error);
      throw error;
    }
  }
};
